function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "exit_to_app-24px",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_253",
  "data-name": "Trazado 253",
  d: "M0,0H31.5V31.5H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_254",
  "data-name": "Trazado 254",
  d: "M12.738,19.613a1.245,1.245,0,0,0,1.762,0l4.488-4.488a1.245,1.245,0,0,0,0-1.762L14.5,8.875a1.246,1.246,0,0,0-1.762,1.762L15.087,13H4.25a1.25,1.25,0,0,0,0,2.5H15.087l-2.35,2.35A1.256,1.256,0,0,0,12.738,19.613ZM23,3H5.5A2.5,2.5,0,0,0,3,5.5V9.25a1.25,1.25,0,0,0,2.5,0V6.75A1.254,1.254,0,0,1,6.75,5.5h15A1.254,1.254,0,0,1,23,6.75v15A1.254,1.254,0,0,1,21.75,23h-15A1.254,1.254,0,0,1,5.5,21.75v-2.5a1.25,1.25,0,0,0-2.5,0V23a2.507,2.507,0,0,0,2.5,2.5H23A2.507,2.507,0,0,0,25.5,23V5.5A2.507,2.507,0,0,0,23,3Z",
  transform: "translate(1.5 1.5)",
  fill: "#fff"
}));

var SvgSignOut = function SvgSignOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signOut.74e3e9d9.svg";
export { ForwardRef as ReactComponent };